<template>
  <main class="rh-people">
    <rh-cabecalho
      pagina="pessoas"
      subtitulo="PESSOAS E PERFIS"
      titulo=""
      descricao=""
      :unidade-id="unidadeId"
      :empresas="empresas"
      mostrar-pessoas
      :mostrar-configuracao="podeAdministrar"
      @empresa-selecionada="selecionarEmpresa"
    />
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message
    ><b-message v-if="importacao" type="is-info" aria-close-label="Fechar" @close="importacao = null"
      >{{ importacao.incluidos }} colaboradores incluídos.
      <ul v-if="importacao.erros.length">
        <li v-for="(item, i) in importacao.erros" :key="i">{{ item }}</li>
      </ul></b-message
    >
    <b-tabs v-model="aba" type="is-boxed" class="rh-tabs">
      <b-tab-item value="pessoas" label="Pessoas">
    <section class="rh-card">
      <div class="rh-card-head">
        <div>

        </div>
        <div class="rh-buttons">
          <b-button
            v-if="isInRole('rh-diretoria')"
            type="is-light"
            icon-left="file-upload-outline"
            :disabled="!perfis.length || !equipes.length"
            @click="modalImportar = true"
            >Importar CSV</b-button
          ><b-button v-if="isInRole('rh-diretoria')" type="is-primary" icon-left="plus" :disabled="!unidadeId || !perfis.length" @click="novo"
            >Novo colaborador</b-button
          >
        </div>
      </div>
      <br>
      
      <div class="rh-people-filters">
        <b-field class="rh-people-search">
          <b-input
            v-model="busca"
            icon="magnify"
            placeholder="Buscar por nome ou e-mail"
            aria-label="Buscar pessoas"
          ></b-input>
        </b-field>
        <b-field class="rh-people-team">
          <b-select v-model="equipeFiltroId" expanded aria-label="Filtrar por equipe">
            <option :value="null">Todas as equipes</option>
            <option v-for="equipe in equipesDisponiveis" :key="equipe.id" :value="equipe.id">{{ equipe.nome }}</option>
          </b-select>
        </b-field>
      </div>
      <b-table :data="filtrados" :loading="loading" paginated :per-page="10" hoverable mobile-cards>
        <b-table-column v-slot="p" field="nome" label="Nome" sortable
          ><strong>{{ p.row.nome }}</strong></b-table-column
        ><b-table-column v-slot="p" field="email" label="E-mail">{{ p.row.email }}</b-table-column
        ><b-table-column v-slot="p" field="perfil" label="Perfil">{{ p.row.perfil }}</b-table-column
        ><b-table-column v-slot="p" field="equipes" label="Equipes">{{
          p.row.equipes.length ? p.row.equipes.join(', ') : 'Sem equipe'
        }}</b-table-column
        ><b-table-column v-slot="p" field="temAcesso" label="Acesso"
          ><b-tag :type="p.row.temAcesso ? 'is-success' : p.row.convitePendente ? 'is-info' : 'is-light'">{{
            p.row.temAcesso ? 'Ativo' : p.row.convitePendente ? 'Convite enviado' : 'Sem acesso'
          }}</b-tag></b-table-column
        ><b-table-column v-slot="p" label="Ações" width="220"
          ><b-button
            size="is-small"
            type="is-light"
            icon-left="pencil"
            :aria-label="'Editar ' + p.row.nome"
            @click="editar(p.row)"
          ></b-button
          ><b-button
            v-if="podeAdministrar && !p.row.temAcesso"
            size="is-small"
            type="is-info"
            icon-left="email-outline"
            :loading="convidandoId === p.row.id"
            @click="convidar(p.row)"
            >Convidar</b-button
          ><b-button
            v-if="podeAdministrar && p.row.id !== $store.state.usuario.funcionarioId"
            size="is-small"
            type="is-light"
            icon-left="account-off-outline"
            :aria-label="'Desativar ' + p.row.nome"
            @click="desativar(p.row)"
          ></b-button
        ></b-table-column>
        <template #empty><div class="rh-empty">Nenhum colaborador encontrado para os filtros selecionados.</div></template>
      </b-table>
    </section>
      </b-tab-item>
      <b-tab-item v-if="podeVerPerfis" value="perfis" label="Perfis">
        <section class="rh-card">
          <div class="rh-card-head">
            <div>
              <p class="rh-kicker">POR EMPRESA</p>
              <h2>Perfis de acesso</h2>
            </div>
            <b-button v-if="podeEditarPerfis" type="is-primary" icon-left="plus" :disabled="!unidadeId" @click="novoPerfil">
              Novo perfil
            </b-button>
          </div>
          <b-field class="rh-search-profile">
            <b-input v-model="buscaPerfil" icon="magnify" placeholder="Buscar perfil por nome" aria-label="Buscar perfis" @input="buscarPerfis"></b-input>
          </b-field>
          <p v-if="!podeEditarPerfis" class="rh-muted">A edição de perfis está disponível para administradores.</p>
          <b-table
            :data="listaPerfis"
            :loading="loadingPerfis"
            paginated
            backend-pagination
            :per-page="20"
            :total="totalPerfis"
            :current-page.sync="paginaPerfis"
            hoverable
            mobile-cards
            @page-change="mudarPaginaPerfis"
          >
            <b-table-column v-slot="p" field="id" label="Código" width="110">{{ p.row.id }}</b-table-column>
            <b-table-column v-slot="p" field="nome" label="Nome"><strong>{{ p.row.nome }}</strong></b-table-column>
            <b-table-column v-if="podeEditarPerfis" v-slot="p" label="Ações" width="110">
              <b-button size="is-small" type="is-light" icon-left="pencil" :aria-label="'Editar ' + p.row.nome" @click="editarPerfil(p.row)"></b-button>
            </b-table-column>
            <template #empty><div class="rh-empty">Nenhum perfil encontrado para esta empresa.</div></template>
          </b-table>
        </section>
      </b-tab-item>
    </b-tabs>
    <b-modal :active.sync="modalImportar" has-modal-card trap-focus aria-role="dialog" aria-modal
      ><div class="modal-card">
        <header class="modal-card-head"><p class="modal-card-title">Importar colaboradores</p></header>
        <section class="modal-card-body">
          <p>
            Envie CSV UTF-8 ou XLSX com as duas primeiras colunas <strong>nome;email</strong>, até 500 pessoas e 1 MB.
          </p>
          <b-field label="Equipe"
            ><b-select v-model="importarEquipeId" expanded placeholder="Selecione uma equipe"
              ><option v-for="x in equipes" :key="x.id" :value="x.id">{{ x.nome }}</option></b-select
            ></b-field
          ><b-field label="Perfil"
            ><b-select v-model="importarNivelId" expanded placeholder="Selecione um perfil"
              ><option v-for="x in perfis" :key="x.id" :value="x.id">{{ x.nome }}</option></b-select
            ></b-field
          ><b-field label="Arquivo CSV ou XLSX"
            ><input
              ref="csv"
              type="file"
              accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              class="input"
          /></b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="modalImportar = false">Cancelar</b-button
          ><b-button
            type="is-primary"
            :disabled="!importarEquipeId || !importarNivelId"
            :loading="salvando"
            @click="importar"
            >Importar</b-button
          >
        </footer>
      </div></b-modal
    >
  </main>
</template>
<script>
import http from '@/http'
import RhCabecalho from '@/components/rh_cabecalho.vue'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
export default {
  name: 'RhPessoas',
  components: { RhCabecalho },
  data() {
    return {
      empresas: [],
      unidadeId: null,
      equipes: [],
      perfis: [],
      pessoas: [],
      aba: 'pessoas',
      listaPerfis: [],
      buscaPerfil: '',
      paginaPerfis: 1,
      totalPerfis: 0,
      loadingPerfis: false,
      busca: '',
      equipeFiltroId: null,
      modalImportar: false,
      importarEquipeId: null,
      importarNivelId: null,
      importacao: null,
      convidandoId: null,
      loading: false,
      salvando: false,
      erro: '',
    }
  },
  computed: {
    ...mapGetters(['isInRole']),
    podeAdministrar() {
      return this.isInRole('rh-diretoria')
    },
    podeVerPerfis() {
      return this.isInRole('rh-diretoria')
    },
    podeEditarPerfis() {
      return this.isInRole('Administrador')
    },
    liderSemDiretoria() {
      return !this.isInRole('rh-diretoria') && this.isInRole('rh-lider')
    },
    equipesDisponiveis() {
      return this.liderSemDiretoria
        ? this.equipes.filter((equipe) => equipe.liderId === this.$store.state.usuario.funcionarioId)
        : this.equipes
    },
    filtrados() {
      const q = this.busca.trim().toLowerCase()
      const equipesPermitidas = this.liderSemDiretoria ? new Set(this.equipesDisponiveis.map((equipe) => equipe.id)) : null
      return this.pessoas.filter((x) =>
        (!q || `${x.nome} ${x.email}`.toLowerCase().includes(q)) &&
        (!equipesPermitidas || (x.equipeIds || []).some((id) => equipesPermitidas.has(id))) &&
        (this.equipeFiltroId === null || (x.equipeIds || []).includes(this.equipeFiltroId))
      )
    },
  },
  created() {
    if (this.$route.query.aba === 'perfis' && this.podeVerPerfis) this.aba = 'perfis'
    this.iniciar()
  },
  watch: {
    aba(valor) {
      if (valor === 'perfis' && this.unidadeId) this.carregarPerfis()
    },
    podeVerPerfis(valor) {
      if (!valor) this.aba = 'pessoas'
    },
  },
  methods: {
    selecionarEmpresa(id) {
      this.unidadeId = id
      this.equipeFiltroId = null
      this.carregar()
      this.paginaPerfis = 1
      this.listaPerfis = []
      if (this.aba === 'perfis') this.carregarPerfis()
    },
    falha(e) {
      this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível concluir a operação. Tente novamente.'
    },
    async iniciar() {
      this.loading = true
      try {
        this.empresas = (await http.get('/api/rh/estrutura/empresas')).data || []
        const unidadeRota = Number(this.$route.query.unidadeId)
        const atual = this.empresas.some((x) => x.id === unidadeRota) ? unidadeRota : Number(this.$store.state.unidadeId)
        this.unidadeId = this.empresas.some((x) => x.id === atual)
          ? atual
          : (this.empresas[0] && this.empresas[0].id) || null
        if (this.unidadeId) {
          await this.carregar()
          if (this.aba === 'perfis') await this.carregarPerfis()
        }
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    async carregar() {
      if (!this.unidadeId) return
      this.loading = true
      try {
        const q = { params: { unidadeId: this.unidadeId } }
        const [equipes, perfis, pessoas] = await Promise.all([
          http.get('/api/rh/estrutura/equipes', q),
          http.get('/api/rh/pessoas/perfis', q),
          http.get('/api/rh/pessoas/colaboradores', q),
        ])
        this.equipes = equipes.data || []
        this.perfis = perfis.data || []
        this.pessoas = pessoas.data || []
        if (this.equipeFiltroId !== null && !this.equipesDisponiveis.some((equipe) => equipe.id === this.equipeFiltroId))
          this.equipeFiltroId = null
        this.importarEquipeId = (this.equipes[0] && this.equipes[0].id) || null
        this.importarNivelId = (this.perfis[0] && this.perfis[0].id) || null
      } catch (e) {
        this.falha(e)
      } finally {
        this.loading = false
      }
    },
    buscarPerfis: debounce(function () {
      this.paginaPerfis = 1
      this.carregarPerfis()
    }, 300),
    async carregarPerfis() {
      if (!this.unidadeId || !this.podeVerPerfis) return
      const unidadeId = this.unidadeId
      this.loadingPerfis = true
      try {
        const { data } = await http.get('/api/manutencao/niveisdeacesso', {
          params: { unidadeId, procurar: this.buscaPerfil.trim(), page: this.paginaPerfis, perPage: 20 },
        })
        if (unidadeId !== this.unidadeId) return
        this.listaPerfis = data.lista || []
        this.totalPerfis = (data.pageCount || 0) * 20
      } catch (e) {
        this.listaPerfis = []
        this.totalPerfis = 0
        this.falha(e)
      } finally {
        this.loadingPerfis = false
      }
    },
    mudarPaginaPerfis(pagina) {
      this.paginaPerfis = pagina
      this.carregarPerfis()
    },
    novoPerfil() {
      this.$router.push({ name: 'rh-perfil-novo', query: { unidadeId: this.unidadeId } })
    },
    editarPerfil(item) {
      this.$router.push({ name: 'rh-perfil-editar', params: { id: item.id }, query: { unidadeId: this.unidadeId } })
    },
    novo() {
      this.$router.push({ name: 'rh-colaborador-novo', query: { unidadeId: this.unidadeId } })
    },
    editar(item) {
      this.$router.push({ name: 'rh-colaborador-editar', params: { id: item.id }, query: { unidadeId: this.unidadeId } })
    },
    async importar() {
      const arquivo = this.$refs.csv && this.$refs.csv.files && this.$refs.csv.files[0]
      if (!arquivo) {
        this.erro = 'Selecione um arquivo CSV ou XLSX.'
        return
      }
      this.salvando = true
      try {
        const form = new FormData()
        form.append('unidadeId', this.unidadeId)
        form.append('equipeId', this.importarEquipeId)
        form.append('nivelId', this.importarNivelId)
        form.append('arquivo', arquivo)
        this.importacao = (await http.post('/api/rh/pessoas/importar', form)).data
        this.modalImportar = false
        await this.carregar()
      } catch (e) {
        this.falha(e)
      } finally {
        this.salvando = false
      }
    },
    convidar(item) {
      this.$buefy.dialog.confirm({
        title: 'Enviar convite',
        message: `Enviar convite de acesso para ${item.email}?`,
        confirmText: 'Enviar',
        cancelText: 'Cancelar',
        type: 'is-info',
        onConfirm: async () => {
          this.convidandoId = item.id
          try {
            await http.post('/api/rh/pessoas/convites', { unidadeId: this.unidadeId, funcionarioId: item.id })
            await this.carregar()
            this.$buefy.toast.open({ message: 'Convite enviado por e-mail.', type: 'is-success' })
          } catch (e) {
            this.falha(e)
          } finally {
            this.convidandoId = null
          }
        },
      })
    },
    desativar(item) {
      this.$buefy.dialog.confirm({
        title: 'Desativar acesso',
        message: `Desativar ${item.nome} nesta empresa? A pessoa perderá o acesso e os vínculos ativos.`,
        confirmText: 'Desativar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: async () => {
          try {
            await http.post(`/api/rh/pessoas/colaboradores/${item.id}/desativar?unidadeId=${this.unidadeId}`)
            await this.carregar()
            this.$buefy.toast.open({ message: 'Acesso desativado.', type: 'is-success' })
          } catch (e) {
            this.falha(e)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.rh-people {
  --navy: #0b1a3e;
  --blue: #007bff;
  --teal: #0e8fa8;
  background: #f4f3f0;
  min-height: 100vh;
  padding: 0 28px 48px;
  border-radius: 18px;
  color: #1c1d24;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-muted {
  color: #667085;
  font-size: 13px;
}
.rh-kicker {
  letter-spacing: 0.15em;
  font-size: 11px;
  font-weight: 800;
  color: var(--teal);
  margin: 0;
}
.rh-card {
  background: #fff;
  border: 1px solid #e7e9ed;
  border-radius: 17px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 20px rgba(11, 26, 62, 0.04);
}
.rh-card h2 {
  font-size: 22px;
  color: var(--navy);
  font-weight: 800;
  margin: 5px 0;
}
.rh-card-head,
.rh-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.rh-empty {
  padding: 28px;
  text-align: center;
  color: #667085;
}
.rh-tabs { margin-top: 18px; }
.rh-tabs ::v-deep .tab-content { padding: 0; }
.rh-search-profile { margin: 18px 0; max-width: 460px; }
.rh-people-filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.rh-people-search { flex: 1 1 300px; }
.rh-people-team { flex: 0 1 240px; }
@media (max-width: 800px) {
  .rh-card-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .rh-buttons {
    flex-wrap: wrap;
  }
}
@media (max-width: 560px) {
  .rh-people {
    padding: 0 14px 30px;
  }
  .rh-card {
    padding: 18px;
  }
}
</style>
